var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftpaginationarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 35,
    rx: 3.5,
    fill: "#FFC300"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 35,
    rx: 3.5,
    stroke: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2309 14.1841C22.4606 14.423 22.4532 14.8028 22.2143 15.0325L19.0641 18L22.2143 20.9675C22.4532 21.1972 22.4606 21.577 22.2309 21.8159C22.0013 22.0547 21.6214 22.0622 21.3826 21.8325L17.7826 18.4325C17.6649 18.3194 17.5984 18.1632 17.5984 18C17.5984 17.8368 17.6649 17.6806 17.7826 17.5675L21.3826 14.1675C21.6214 13.9378 22.0013 13.9453 22.2309 14.1841Z",
    fill: "#344051"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftpaginationarrow);
export default __webpack_public_path__ + "static/media/leftpaginationarrow.83b9d3ed48b73a162b77257b65f71268.svg";
export { ForwardRef as ReactComponent };